const THOUSAND_SEPARATOR_REGEXP = /\B(?=(\d{3})+(?!\d))/g

// Groups digits by thousands with a space and a dot decimal (e.g. 14899.756 -> "14 899.76"),
// matching the separator style used across the app's currency formatting.
const formatNumber = (value: number, decimals = 2): string => value.toFixed(decimals).replace(THOUSAND_SEPARATOR_REGEXP, ' ')

export default formatNumber
